export default __webpack_public_path__ + "static/media/spotify.7b7d414e.png";